/* file description */
import { SPSteps } from './../SPSteps/index';
import React, { FC, useEffect, useMemo, useState } from 'react';
import {
  queryProcessData,
  postRecordList,
  queryAllProcessData,
  queryProcessVariables,
} from '../SPSteps/effects/process.service';
import Cookies from 'js-cookie';
import { SPStepsWithApiProps } from './type';
import { cloneDeep } from 'lodash';
import { getFormatData, getEndNode } from '@/services/stepNodes.service';
import {
  ASSIGNEE_ROLE_SCOPE,
  ASSIGNEE_TYPE,
  ProcessNode,
  NeedAssignNode,
  ProcessComment,
  ProcessTemplateEdge,
  ProcessTemplateNode,
  ProcessTemplateNodeExt,
  ProcessVariables,
  RenderFormatProcessTemplateNode,
  RenderProcessTemplateNode,
  RenderFormatDescription,
} from '@/types/process';
import { getUserInfoCache, UserInfo } from '@/api/system';
import { Layout } from 'antd';
import { useAsyncEffect } from 'ahooks';

const { Sider } = Layout;

export const SPStepsWithApi: FC<SPStepsWithApiProps> = ({
  taskId,
  dataId,
  version = '1',
  onSuccess,
  onFail,
  onCloseStep,
  onFold,
  collapsed,
  siderWidth,
  moduleList,
  mainModuleId,
  values,
  taskInfo,
  recordId,
  pageType,
  refList,
  utils,
}) => {
  const userAccount = Cookies.get('userAccount');
  const [processData, setProcessData] = useState<any>([]);
  // 当前正在审批中的节点
  const [activeData, setActiveData] = useState<any>();
  const [current, setCurrent] = useState(1);
  const [status, setStatus] = useState<
    'error' | 'wait' | 'process' | 'finish' | undefined
  >(undefined);
  const [historyProcessData, setHistoryProcessData] = useState<any[]>([]);
  const [nodesData, setNodesData] = useState<Record<string, any>[]>([]);

  const hasDuplicateIds = (arr: any[]) => {
    const seen = new Set();
    return arr.some((o) => seen.has(o.nodeId) || !seen.add(o.nodeId));
  };
  const getHistoryData = (res: any, nodeList: any[], edgeList: any[]) => {
    const resNodeList = res?.nodes || [];
    const isRollback = hasDuplicateIds(resNodeList);
    const resState = res?.state || '';
    resNodeList.forEach((el: any) => {
      const node = nodeList.find((item: any) => item.id === el.nodeId);
      const approvalType = node?.title?.approvalType;
      const noComplete = el.comments?.filter((com: any) => !com.complete) || [];
      const isComplete = el.comments?.filter((com: any) => com.complete);
      if (approvalType === 'OR') {
        el.complete = isComplete.length > 0;
      } else {
        el.complete = noComplete?.length === 0;
      }
    });
    const renderList = isRollback
      ? cloneDeep(res?.nodes).map((comData: any) => {
          const el = (nodeList || []).find(
            (el: any) => comData.nodeId === el.id,
          );
          const elData = {
            ...(el || {}),
            ...comData,
            showNode: !!el,
          };
          const rederData = getFormatData(elData);
          return rederData;
        })
      : cloneDeep(nodeList).map((el: any) => {
          const comData = (res?.nodes || []).find(
            (nod: any) => nod.nodeId === el.id,
          );
          const elData = {
            ...el,
            ...(comData || {}),
            showNode: !!comData || el?.shape === 'start-node',
          };
          const rederData = getFormatData(elData);
          return rederData;
        });
    const isFinish = !resNodeList.find((el: any) => el.complete === false);
    const newProcessData = renderList.filter((el: any) => el.showNode);
    const isComplete = resState === 'COMPLETED';
    if (isFinish && isComplete && resNodeList.length > 0) {
      const ativeId = newProcessData[newProcessData.length - 1].id;
      const endNode = getEndNode(ativeId, edgeList, nodeList);
      if (endNode) {
        newProcessData.push(endNode);
      }
    }
    const nodeLength = newProcessData.length;
    const newCurrent =
      isFinish && isComplete && resNodeList.length > 0
        ? nodeLength
        : nodeLength - 1;
    let newStatus: string;
    if (newProcessData[nodeLength - 1]?.isRefuse) {
      newStatus = 'error';
    }
    return {
      processData: newProcessData,
      current: newCurrent,
      status: newStatus,
    };
  };
  const getData = async () => {
    // 获取流程模版配置
    const proRes = await postRecordList({
      app_id: 'tech',
      model_id: 'approval_design',
      relation_task_id: taskId,
    });
    const resList: ProcessTemplateNode[] = proRes?.data
      ? proRes?.data[0]?.schema_values?.nodes || []
      : [];
    const edgeList: ProcessTemplateEdge[] = proRes?.data
      ? proRes?.data[0]?.schema_values?.edges || []
      : [];
    const nodeList: ProcessTemplateNodeExt[] = resList.map(
      (el: ProcessTemplateNode) => {
        const name = el?.data?.basicConfiguration?.name;
        //  "SEQUENTIAL" 1顺序签 "PARALLEL" 2会签 "OR" 或签
        const type = el?.data?.basicConfiguration?.approvalMode;
        return {
          name,
          title: {
            label: name,
            approvalType: type,
          },
          ...(el || {}),
        };
      },
    );
    const params = { taskId, dataId, version };

    // 获取当前流程节点数据
    const res = await queryProcessData(params);
    const allRes = await queryAllProcessData(params);

    setNodesData(nodeList);

    const historyData = cloneDeep(allRes).map((data: any) => {
      return getHistoryData(data, nodeList, edgeList);
    });

    setHistoryProcessData(historyData);
    const resNodeList: ProcessNode[] = res?.nodes || [];
    const isRollback = hasDuplicateIds(resNodeList);
    resNodeList.forEach((el: ProcessNode) => {
      const node = nodeList.find(
        (item: ProcessTemplateNodeExt) => item.id === el.nodeId,
      );
      const approvalType = node?.title?.approvalType;
      const noComplete =
        el.comments?.filter((com: ProcessComment) => !com.complete) || [];
      const isComplete = el.comments?.filter(
        (com: ProcessComment) => com.complete,
      );
      if (approvalType === 'OR') {
        el.complete = isComplete.length > 0;
      } else {
        el.complete = noComplete?.length === 0;
      }
    });

    // 若当前节点需要为其他节点分配审批人，且指定为同级用户，则需要给出当前审批人信息
    const userInfo = await getUserInfoCache();
    const resNodeListWithSponarDeptId: ProcessNode[] = res?.nodes || [];
    resNodeListWithSponarDeptId.forEach((el: ProcessNode) => {
      el.needAssignNodes?.forEach((assignNode: NeedAssignNode) => {
        const nodeConfig = nodeList.find(
          (node: ProcessTemplateNode) => node.id === assignNode.assigned_node,
        );
        const basicConfiguration = nodeConfig?.data?.basicConfiguration;
        if (basicConfiguration) {
          const { assigneeType, assigneeRoleScope } = basicConfiguration;
          if (assigneeType && assigneeRoleScope) {
            assignNode.userAccount =
              assigneeType === ASSIGNEE_TYPE.NODE &&
              assigneeRoleScope === ASSIGNEE_ROLE_SCOPE.USER_DEPARTMENT_ROLE
                ? userInfo.user.userAccount
                : undefined;
          }
        }
      });
    });

    // 组装模版和节点数据成为渲染数据
    const renderList: RenderFormatProcessTemplateNode[] = isRollback
      ? cloneDeep(resNodeListWithSponarDeptId).map((comData: ProcessNode) => {
          const el: ProcessTemplateNodeExt | undefined = nodeList.find(
            (el: ProcessTemplateNodeExt) => comData.nodeId === el.id,
          );
          const elData: RenderProcessTemplateNode = {
            ...(el || {}),
            ...comData,
            showNode: !!el,
          };
          const rederData = getFormatData(elData);
          return rederData;
        })
      : cloneDeep(nodeList).map((el: ProcessTemplateNodeExt) => {
          const comData:
            | ProcessNode
            | undefined = resNodeListWithSponarDeptId.find(
            (nod: ProcessNode) => nod.nodeId === el.id,
          );
          const elData: RenderProcessTemplateNode = {
            ...el,
            ...(comData || {}),
            showNode: !!comData || el?.shape === 'start-node',
          };
          const rederData = getFormatData(elData);
          return rederData;
        });
    const isFinish = !resNodeList.find((el: any) => el.complete === false);
    const newProcessData = renderList.filter((el: any) => el.showNode);
    const resState = res?.state || '';
    const isComplete = resState === 'COMPLETED';
    if (isFinish && isComplete && resNodeList.length > 0) {
      const ativeId = newProcessData[newProcessData.length - 1].id;
      const endNode = getEndNode(ativeId, edgeList, nodeList);
      if (endNode) {
        newProcessData.push(endNode);
      }
    }
    const nodeLength = newProcessData.length;
    const newCurrent =
      isFinish && isComplete && resNodeList.length > 0
        ? nodeLength
        : nodeLength - 1;
    setCurrent(newCurrent);
    getActiveData(newProcessData[nodeLength - 1]);
    setProcessData(newProcessData);
    if (newProcessData?.length > 1) {
      onCloseStep(true);
    }
  };

  const getActiveData = (data: any) => {
    if (data?.isRefuse) {
      setActiveData(null);
      setStatus('error');
      return;
    }
    if (data?.shape === 'end-node') {
      setActiveData(null);
      return;
    }
    const approverSchema = {
      needAssign: data?.needAssign,
      needAssignNodes: data?.needAssignNodes,
    };
    const commentsList = data?.description || [];
    const nextIndex = commentsList.map((el: any) => el.complete).indexOf(false);
    const nextArr = commentsList.slice(nextIndex);
    // 会签
    const qType = data?.title?.approvalType;
    if (qType === 'PARALLEL' || qType === 'OR') {
      const newData = nextArr.find((el: any) => el.userId === userAccount);
      if (newData) {
        setActiveData({
          ...newData,
          approverSchema,
          urlTaskId: taskId,
        });
      } else {
        setActiveData(null);
      }
    }
    // 顺序签
    if (qType === 'SEQUENTIAL') {
      const newData = commentsList[nextIndex];
      if (newData.userId === userAccount) {
        setActiveData({
          ...newData,
          approverSchema,
          urlTaskId: taskId,
        });
      } else {
        setActiveData(null);
      }
    }
  };

  useEffect(() => {
    // 延迟1秒
    setTimeout(() => {
      getData();
    }, 1000);
  }, []);

  // 步骤条是否展示
  const stepsShow = useMemo(() => {
    const mainModule = moduleList?.find(
      (moduleItem: Record<string, any>) => moduleItem.moduleID === mainModuleId,
    );

    const mainModuleHandle = mainModule?.handle;

    // 是否数据被删 即主模型的下的values数据都是空
    const noValue = Object.values(values?.[mainModuleHandle] ?? {}).every(
      (value) => value === null || value === undefined,
    );

    return (
      taskInfo.flag === 'true' &&
      recordId &&
      (pageType === 'view' ||
        (pageType === 'edit' &&
          processData?.[current]?.data?.basicConfiguration?.authority ===
            'EDITABLE')) &&
      !noValue
    );
  }, [
    taskInfo,
    recordId,
    pageType,
    moduleList,
    mainModuleId,
    values,
    processData,
    current,
  ]);

  const matchRole = (
    userRoles: any[],
    currentConfig: { assigneeRole?: any[] | undefined },
  ) => {
    const { assigneeRole = [] } = currentConfig;
    return userRoles.some((role) => assigneeRole.includes(role));
  };

  useAsyncEffect(async () => {
    const userInfo: UserInfo = await getUserInfoCache();
    const userRoles = userInfo?.myRoles.map((role) => role.roleNumber) ?? [];

    if (
      pageType === 'view' &&
      processData?.[current]?.data?.basicConfiguration?.authority ===
        'EDITABLE' &&
      stepsShow &&
      matchRole(userRoles, processData?.[current]?.data?.basicConfiguration)
    ) {
      const path = location.pathname
        .replace(/^\/pro/, '')
        .replace(/\/detail/, '/edit');
      utils?.buiNavigate({
        type: 'spa',
        path,
      });
    }

    if (
      pageType === 'edit' &&
      processData.length > 0 &&
      processData.length > 0 &&
      processData.length === nodesData.length
    ) {
      const path = location.pathname
        .replace(/^\/pro/, '')
        .replace(/\/edit/, '/detail');
      utils?.buiNavigate({
        type: 'spa',
        path,
      });
    }
  }, [pageType, processData, stepsShow, current, activeData, nodesData]);

  return (
    <>
      {stepsShow && (
        <Sider
          style={{
            background: '#fff',
            marginLeft: '10px',
            display: collapsed ? 'block' : 'none',
          }}
          width={siderWidth}
        >
          <SPSteps
            items={processData}
            current={current}
            status={status}
            activeData={activeData}
            reload={getData}
            onSuccess={onSuccess}
            onFail={onFail}
            historyProcessData={historyProcessData}
            onFold={onFold}
            refList={refList}
          />
        </Sider>
      )}
    </>
  );
};

export default SPStepsWithApi;
